<template>
  <b-container style="padding-top: 150px;">
    <p class="c3"><span>Data Policy for HeartBeatFam</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">Effective Date: September 14, 2023</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">1. Introduction</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >Welcome to HeartBeatFam. This Data Policy (&quot;Policy&quot;)
        outlines how we collect, use, store, and protect data on our platform to
        provide healthcare and caregiving services to our users. Protecting your
        data and privacy is of utmost importance to us.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">2. Data Collection</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >2.1. Information You Provide: When you use HeartBeatFam, you may
        voluntarily provide us with personal information such as contact
        details, medical information, and caregiving needs. This information is
        used to deliver our services effectively.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >2.2. Automated Data Collection: We collect data automatically through
        cookies, log files, and other tracking technologies to enhance your user
        experience, analyze user behavior, and improve our services. This data
        includes device information, log data, and usage information.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">3. Data Usage</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >3.1. Service Delivery: We use the data you provide to offer healthcare
        and caregiving services, including connecting families, facilitating
        caregiving tasks, and tracking health-related data as needed.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >3.2. Communication: We may use your contact information to communicate
        with you, respond to inquiries, and provide customer support.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >3.3. Improvement: We analyze data to improve our services, enhance user
        experiences, and develop new features and offerings.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >3.4. Legal Compliance: We process data to comply with legal obligations
        and enforce our Terms and Conditions.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">4. Data Sharing</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >4.1. Service Providers: We may share data with trusted service
        providers who assist us in delivering and enhancing our services.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >4.2. Legal Compliance: We may disclose data to comply with legal
        requirements, protect our rights, and respond to lawful requests from
        government authorities.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >4.3. Business Transfers: In the event of a merger, acquisition, or sale
        of assets, data may be transferred to the acquiring entity.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">5. Data Security</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >We employ reasonable measures to protect data from unauthorized access,
        disclosure, alteration, or destruction. However, no data transmission or
        storage method is entirely secure, and we cannot guarantee absolute
        security.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">6. Data Retention</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >We retain data for as long as necessary to fulfill the purposes
        outlined in this Policy, unless a longer retention period is required by
        law.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">7. Your Data Rights</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >7.1. Access and Correction: You have the right to access and update
        your personal data. You can do this by logging into your account or
        contacting us.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >7.2. Data Deletion: You can request the deletion of your account and
        associated data, subject to legal and contractual obligations.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">8. Children&#39;s Data</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >HeartBeatFam is not intended for children under the age of 18, and
        we do not knowingly collect data from children. If you believe we have
        inadvertently collected data from a child, please contact us.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">9. Changes to this Data Policy</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >We may update this Data Policy to reflect changes in our data practices
        or for legal reasons. Any material changes will be communicated to you,
        and the updated Policy will be posted on the HeartBeatFam
        platform.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3"><span class="c0">10. Contact Us</span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >If you have any questions or concerns about this Data Policy or our
        data practices, please contact us at :</span
      >
    </p>
    <p class="c7">
      <span class="c2"
        >9461 Charleville Blvd. #888<br />Beverly Hills, CA 90212<br />hi@heartbeatfam.com<br />+1
        (323) 739-8664</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c3">
      <span class="c0"
        >By using HeartBeatFam, you acknowledge that you have read,
        understood, and agree to be bound by this Data Policy.</span
      >
    </p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c1"><span class="c0"></span></p>
    <p class="c1"><span class="c0"></span></p>
  </b-container>
</template>

<script>
export default {
  name: "Policy_Data"
};
</script>
